<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Abonos</h3>
      </div>
    </div>
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Usuario</th>
            <th># Abono</th>
            <th>$ Abono</th>
            <th>Observación</th>
            <th>Dirección de abono</th>
            <th>
              <button
                v-show="puedeRegistrarAbonos"
                type="button"
                @click="agregar"
                class="btn-success"
              >
                <i class="fa fa-plus"></i>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="abonos.length === 0">
            <td colspan="7">
              <strong>No se ha agregado abonos</strong>
            </td>
          </tr>
          <tr v-for="(abono, index) in abonos" :key="index">
            <td>
              {{ abono.fecha_abono }}
            </td>
            <td>
              {{ abono.usuario.nombre_usuario }}
            </td>
            <td>
              {{ abono.numero_secuencia }}
            </td>
            <td>
              {{ moneyFormat(abono.valor_abono) }}
            </td>
            <td>
              {{ abono.observacion }}
            </td>
            <td>
              {{ abono.direccion_abono }}
            </td>
            <td>
              <button
                v-show="puedeEditarAbonos"
                type="button"
                @click="editar(index)"
                class="btn-info btn--text"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                type="button"
                @click="imprimir(index)"
                class="btn-success btn--text"
              >
                <i class="fa fa-print"></i>
              </button>
              <button
                v-show="puedeAnularAbonos"
                type="button"
                @click="eliminar(index)"
                class="btn-danger btn--text"
              >
                <i class="fa fa-trash"></i>
              </button>
              <button
                type="button"
                v-show="abono.coordenadas != null"
                @click="verMapa(abono)"
                class="btn-warning btn--text"
              >
                <i class="fa fa-map"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-buttons">
      <button
        type="button"
        @click="$emit('cerrar')"
        class="btn-danger btn--text"
      >
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
    <modal
      name="abonoPedido"
      height="auto"
      width="65%"
      adaptive
      reset
      resizable
      scrollable
    >
      <abono-pedido
        @abonoAlmacenado="abonoAlmacenado"
        v-model="selectedAbonoPedido"
        ref="abonoPedido"
        @cancelar="cancelar"
        :pedidoId="pedidoId"
      ></abono-pedido>
    </modal>
  </div>
</template>

<script>
import AbonoPedido from "./AbonoPedido.vue";
export default {
  components: {
    AbonoPedido,
  },
  props: {
    puedeRegistrarAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditarAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAnularAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    pedidoId: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: function () {
    return {
      abonos: [],
      moneyFormat: moneyFormat,
      selectedAbonoPedido: null,
      nuevoAbono: false,
      selectedIndex: -1,
    };
  },
  methods: {
    verMapa: function (abono) {
      window.open(
        "https://maps.google.com?q=" +
          abono.coordenadas.coordinates[1] +
          "," +
          abono.coordenadas.coordinates[0],
        "_blank"
      );
    },
    imprimir: function (index) {
      let abono = this.abonos[index];
      window.open(url + "/logistica/abono/" + abono.id + "/imprimir", "_blank");
    },
    eliminar: function (index) {
      let abono = this.abonos[index];
      if (abono.id != null && abono.id != "") {
        swal({
          title: "¿Deseas anular el abono?",
          text: "Se requiere confirmación",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            axios
              .post(url + "/logistica/abonos/" + abono.id, {
                _method: "DELETE",
              })
              .then(() => {
                swal(
                  "El abono fue anulado exitósamente.",
                  "Realizado",
                  "success"
                );
                this.cargarAbonos();
              })
              .catch(() => {
                swal("Hubo un error, intente nuevamente.", "Error", "error");
              });
          }
        });
      } else this.abonos.splice(index, 1);
    },
    editar: function (index) {
      this.selectedAbonoPedido = this.abonos[index];
      this.selectedIndex = index;
      this.nuevoAbono = false;
      this.$modal.show("abonoPedido");
    },
    abonoAlmacenado: function () {
      this.nuevoAbono = false;
      this.selectedIndex = -1;
      this.cargarAbonos();
      this.$modal.hide("abonoPedido");
    },
    agregar: function () {
      let abono = {
        fecha_abono: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        valor_abono: 0,
        observacion: "",
        usuario: {
          nombre_usuario: "",
        },
        cobro_oficina: true
      };
      this.selectedIndex = this.abonos.push(abono) - 1;
      this.selectedAbonoPedido = abono;
      this.nuevoAbono = true;
      this.$modal.show("abonoPedido");
    },
    cargarAbonos: function () {
      axios
        .get(url + "/logistica/abonos/" + this.pedidoId)
        .then(({ data }) => {
          this.abonos = data;
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    cancelar: function () {
      this.$modal.hide("abonoPedido");
      if (this.nuevoAbono) {
        this.abonos.splice(this.selectedIndex, 1);
        this.nuevoAbono = false;
      }
    },
  },
  mounted: function () {
    this.cargarAbonos();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/AbonosPedido.vue